import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { HEADER_SPACING_PRESETS } from '@insurancemenu/imenu-components-lib';
import { RouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { useIMQAddEmployeesPageStore } from 'store/pages/quote/imq-add-employees/pageStore';
import { ExpectedGroupSizeModal } from 'components/quote/add-employees/ExpectedGroupSizeModal';
import { EditExpectedGroupSizeModal } from 'components/quote/add-employees/EditExpectedGroupSizeModal';
import { ExpectedGroupSizeInfoBlock } from 'components/quote/add-employees/ExpectedGroupSizeInfoBlock';
import { IMQTableManagementPanel } from './IMQTableManagementPanel';
import { IMQAddEmployeesTable } from './IMQAddEmployeesTable';

// TESTING_POLICY: CYPRESS_ONLY

export const PageContent: React.FC = observer(() => {
  const pageStore = useIMQAddEmployeesPageStore();
  const {
    onComplete,
    stepCanComplete,
    expectedGroupSizeModalStore,
    editExpectedGroupSizeModalStore,
    showExpectedGroupSize,
    expectedGroupSize,
  } = pageStore;

  useEffect(() => {
    void pageStore.getInitialData();
  }, []);

  const showGroupSizeInfo = showExpectedGroupSize && !!expectedGroupSize;

  return (
    <QuoteFlowLayout
      flowDelegate={pageStore.flowDelegate}
      pageId={RouteV2Id.IMQ_ADD_EMPLOYEES}
      pageHeader={{
        subtitleMaxWidth: '42rem',
        ...(showGroupSizeInfo ? { spacing: HEADER_SPACING_PRESETS.withTopSectionAndActionBelow } : {}),
      }}
      isPageLoading={pageStore.flowDelegate.isInitialDataLoading}
      pageFooter={{
        onComplete,
        disableCompleteButton: !stepCanComplete,
      }}
    >
      {showGroupSizeInfo ? (
        <ExpectedGroupSizeInfoBlock
          groupSize={expectedGroupSize}
          onEdit={(): void => editExpectedGroupSizeModalStore.open()}
        />
      ) : null}
      <IMQTableManagementPanel />
      <IMQAddEmployeesTable />
      <ExpectedGroupSizeModal modalStore={expectedGroupSizeModalStore} />
      <EditExpectedGroupSizeModal modalStore={editExpectedGroupSizeModalStore} />
    </QuoteFlowLayout>
  );
});
